import type { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

import { LoggerService } from '@accesso/cc-std-lib';
import { LocaleModel } from '@accesso/cc-ui/model';
import { JsonApiService } from '@accesso/ng-json-api';

import { getNormalizedRoute } from '../../feature/routing/routing.utils';

/**
 * This function will prefetch locales on a route. Define the `prefetchLocales` property on the route data to specify which locales to prefetch.
 *
 * Example Route that fetches the 'common' and 'templateerror' sections:
 *
 *  {
 *    path: 'home',
 *    resolve: { prefetchLocalesResolve },
 *    data: { prefetchLocales: ['common', 'templateerror'] },
 *    component: HomeComponent,
 *  }
 *
 * @param route The Activated Route Snapshot
 * @param state The Router State Snapshot
 */
export const prefetchLocalesResolve: ResolveFn<void> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const api = inject(JsonApiService);
	const logger = inject(LoggerService);
	const locales = route.data['prefetchLocales'];

	if (!Array.isArray(locales)) {
		return logger.warn(`prefetchLocalesResolve: 'prefetchLocales' is not an array on /${getNormalizedRoute(state.root)}`);
	}

	api.findMany(LocaleModel, locales);
};
